import axios from 'axios';

/* eslint-disable */
//GA custom demensions
function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let sessionIdCookie = getCookie('sessionIdCookie');
let lastInteractionTime = getCookie('lastInteractionTime');
let date = new Date();
let currentTime = date.getTime();

if (sessionIdCookie === "") {
  sessionIdCookie = sessionId();
  setCookie('sessionIdCookie', sessionIdCookie);
  setCookie('lastInteractionTime', currentTime);
} else {
  if ((currentTime - lastInteractionTime) / 1000 / 60 > 30) {
    sessionIdCookie = sessionId();
    setCookie('sessionIdCookie', sessionIdCookie);
    setCookie('lastInteractionTime', currentTime);
  }
}

//Session ID
function sessionId() {
  return new Date().getTime() + '.' + Math.random().toString(36).substring(5);
}

const getTimeStamp = new Promise(function (resolve) {
  const url = `${process.env.VUE_APP_INDIGO_API_URL}/api/v1/analytics/time.php`;
  axios.get(url).then((time) => {
    resolve(time.data);
  })
});

/*-- Google Tag Manager --*/
(function (w, d, s, l, i) {
  w[l] = w[l] || []; w[l].push({
    'gtm.start':
      new Date().getTime(), event: 'gtm.js'
  }); var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
      'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-NXWLDV');


getTimeStamp.then(function (time) {
  dataLayer.push({
    'sessionId': sessionIdCookie,
    'eventTimeStamp': time
  });
});